/**
 * Age-based calculations for derived variables (kept separate from weightCalc,
 * which is weight/goal-date/kg math).
 */

export interface AgeDecadeInput {
  age: number
}

/**
 * Age rounded down to its decade bucket for copy like "men in their 40s".
 * 43 → 40, 40 → 40, 49 → 40. Clamped to a minimum of 20 so 18-19 read as
 * "in their 20s" rather than the unidiomatic "10s". Null for invalid / non-positive ages.
 */
export function getAgeDecade({ age }: AgeDecadeInput): number | null {
  const a = Number(age)
  if (!Number.isFinite(a) || a <= 0) return null
  return Math.max(20, Math.floor(a / 10) * 10)
}
